interface ILogoProps {
  className?: string;
  logoLabel?: string;
  logoSrc?: string;
}

const DefaultLogoSrc = 'https://cms.cdn.neuronation.com/assets/opxp/logo.svg';

export default function Logo({ className, logoLabel = 'NeuroNation', logoSrc = DefaultLogoSrc }: ILogoProps) {
  return <img className={className} alt={logoLabel} src={logoSrc} />;
}
